import { render, staticRenderFns } from "./meezanBeneficiaryComponent.vue?vue&type=template&id=2b9ae24a&"
import script from "./meezanBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./meezanBeneficiaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports